import React, { useMemo } from "react"
import { Box, Typography } from "@material-ui/core"
import styles from "./styles"
import PropTypes from "prop-types"
import formatNumberWithCommas from "../../../../utils/formatNumberWithCommas"

const SimpleExpenseTotal = ({ data = [], billApprovalPage = false }) => {
  const classes = styles()

  const total = useMemo(
    () => {
      let newArray = []
      data.map(x => {
        x.expenses.map(y => {
          if (billApprovalPage) {
            newArray = [
              ...newArray,
              y.is_percentage
                ? y.quantity * y.actual_rate +
                  y.quantity * y.actual_rate * (y.client_rate / 100) -
                  y.discount
                : y.quantity * y.actual_rate + y.client_rate - y.discount,
            ]
          } else {
            newArray = [...newArray, y.quantity * y.actual_rate]
          }
        })
      })
      return newArray.reduce((partial_sum, a) => partial_sum + a, 0)
    },
    [JSON.stringify(data)]
  )

  const additional = useMemo(
    () => {
      if (billApprovalPage) {
        let newArray = []
        data.map(x => {
          x.additional_expenses.map(y => {
            if (billApprovalPage) {
              newArray = [
                ...newArray,
                y.is_percentage
                  ? y.quantity * y.actual_rate +
                    y.quantity * y.actual_rate * (y.client_rate / 100) -
                    y.discount
                  : y.quantity * y.actual_rate + y.client_rate - y.discount,
              ]
            } else {
              newArray = [...newArray, y.quantity * y.actual_rate]
            }
          })
        })
        return newArray.reduce((partial_sum, a) => partial_sum + a, 0)
      } else {
        return 0
      }
    },
    [JSON.stringify(data)]
  )
  return (
    <Box className={classes.totalContainer}>
      <Box width="20%" className={classes.subContainer}>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          className={classes.totalBox}
        >
          <Typography
            style={{ textAlign: "left" }}
            className={classes.blueTitles}
          >
            TOTAL
          </Typography>
          {/* <InfoIcon
              style={{ color: "#000000", opacity: "0.3", fontSize: "14px" }}
            /> */}
        </Box>
        <Box
          className={classes.totalNumberBox}
          style={{ textAlign: "right", fontSize: "1rem" }}
        >
          ${" "}
          {billApprovalPage
            ? formatNumberWithCommas(total + additional)
            : formatNumberWithCommas(total)}
        </Box>
      </Box>
    </Box>
  )
}

SimpleExpenseTotal.propTypes = {
  data: PropTypes.array,
  billApprovalPage: PropTypes.bool,
}

export default SimpleExpenseTotal
